<template>
  <form v-if="!isLoading" @submit.prevent="onSubmit()">
    <div class="row">
      <div class="col-12">
        <b-checkbox v-model="banner.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-start">
        <div class="app-radio" required>
          <label>Mostrar o banner</label>
          <div class="app-radio__options">
            <b-radio
              v-for="type in bannerTypes"
              :key="type[0]"
              v-model="banner.type"
              :native-value="type[0]"
              >{{ type[1] }}</b-radio
            >
          </div>
        </div>
        <app-network-select
          v-if="isNetworkType"
          v-model="banner.network_ids"
          class="network-select"
          :errors="errors.network_ids"
        ></app-network-select>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <app-input
          v-model="banner.url"
          label="Link"
          :errors="errors.url"
        ></app-input>
        <b-checkbox v-model="banner.new_window"
          >Abrir em nova janela</b-checkbox
        >
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <app-file-picker
          v-model="imageToCrop"
          label="Imagem"
          accept="image/*"
          flag="banner"
          @fileDeleted="() => (this.banner.image = '')"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="19 / 5"
          @croppedImage="onImageCropped"
        ></app-image-cropper>

        <img
          v-if="banner.image"
          :src="banner.image"
          alt="Imagem do Banner"
          class="banner-preview"
        />

        <!-- <p class="message" v-if="!imageToCrop">
          *Enviar uma imagem com o tamanho mínimo de: 1920x1080.
        </p> -->
      </div>
      <div class="col-6">
        <app-file-picker
          v-model="mobileImageToCrop"
          label="Imagem Mobile"
          accept="image/*"
          flag="banner_mobile"
          @fileDeleted="() => (this.banner.image_mobile = '')"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="mobileImageToCrop"
          :src="mobileImageToCrop"
          :aspectRatio="1.91 / 1"
          @croppedImage="onMobileImageCropped"
        ></app-image-cropper>

        <img
          v-if="banner.image_mobile"
          :src="banner.image_mobile"
          alt="Imagem Mobile Banner"
          class="banner-preview"
        />

        <!-- <p class="message" v-if="!mobileImageToCrop">
          *Enviar uma imagem com o tamanho mínimo de: 1080x608.
        </p> -->
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import BannerService from '@/services/banner.service';
import { BannerTypeEnum, BannerTypeLabel } from '@/enums/BannerTypeEnum';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'banners-form',
  props: ['id', 'errors', 'saving'],

  components: { AppImageCropper },
  data: () => {
    return {
      imageToCrop: null,
      mobileImageToCrop: null,
      isLoading: true,
      bannerTypes: Array.from(BannerTypeLabel),
      banner: {
        active: true,
        type: BannerTypeEnum.NETWORKS,
        url: null,
        new_window: false,
        image: null,
        image_mobile: null,
        network_ids: [],
      },
    };
  },
  validations() {
    return {
      banner: {
        type: { required },
        image: { required },
        image_mobile: { required },
      },
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.banner);
    },
    loadBanner(id) {
      BannerService.getId(id)
        .then(({ data: banner }) => (this.banner = banner))
        .finally(() => (this.isLoading = false));
    },
    onMobileImageCropped(value) {
      this.banner.image_mobile = value;
      this.mobileImageToCrop = '';
    },
    onImageCropped(value) {
      this.banner.image = value;
      this.imageToCrop = '';
    },
  },
  computed: {
    isNetworkType() {
      return this.banner.type == BannerTypeEnum.NETWORKS;
    },
  },
  beforeMount() {
    if (this.id) this.loadBanner(this.id);
    else this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.banner-preview {
  max-height: 140px;
  object-fit: cover;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}

.network-select,
.app-radio {
  display: inline-block;
}

.network-select {
  margin-left: 18px;
  margin-bottom: 14px;
}
</style>
